import { ctaContainerStyles, linkButtonStyles } from 'auth/AuthStyles';
import { Provider } from 'react-redux';
import { REGISTER } from 'portal/constants/Routes';
import AuthLayout from 'auth/AuthLayout';

import { configureStore } from '@reduxjs/toolkit';
import EmailPasswordLoginForm from 'components/forms/EmailPasswordLoginForm';
import LinkButton from '@opploans/link-button-component/LinkButton';
import React from 'react';
import reducer from 'reducers/reducer';

const store = configureStore({
  reducer,
  preloadedState: {
    errors: {},
    isDisabled: {},
    email: '',
    password: ''
  }
});

function EmailPasswordLogin({ navigate }) {
  return (
    <AuthLayout
      title='Welcome!'
      subTitle='Log in to continue to your account.'
      subHeaderStyles={{ textAlign: 'center' }}
    >
      <Provider store={store}>
        <EmailPasswordLoginForm navigate={navigate} />
      </Provider>
      <div css={ctaContainerStyles}>
        <LinkButton
          lightBackground
          additionalStyle={linkButtonStyles}
          onClick={() => navigate(REGISTER)}
        >
          Don’t have an account? Apply for a loan here
        </LinkButton>
      </div>
    </AuthLayout>
  );
}

export default EmailPasswordLogin;
